import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  contactToSalesForm: FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;

  constructor(
    // private route: ActivatedRoute,
    // private sharedService: SharedService,
    // public dialog: MatDialog,
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    // this.contactToSalesForm = fb.group({
    //   'saleFormemail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
    // })
    
  }
  email: any;

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../assets/js/hubslider.js', function () { });
    }
    
    this.titleService.setTitle('Trinka - 학술 및 기술 글쓰기에 적합한 문법 검사');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka는 학술 및 기술 글쓰기에 적합한 유일한 AI 문법 및 언어 검사 도구입니다. Trinka는 문법 차원을 넘어, 어조, 스타일, 가독성 등 많은 측면에서 귀하의 글을 개선해 출판할 준비를 갖춥니다!' });
    this.metaTagService.updateTag({ name: 'keywords', content: '학술 및 기술 글쓰기에 적합한 문법 검사 도구, 고급 문법 교정, 학술 글쓰기 지원, 기술 글쓰기 지원, 고급 문법 검사, 자동 문법 교정, 학술 글쓰기 AI 툴' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka - 학술 및 기술 글쓰기에 적합한 문법 검사' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka는 학술 및 기술 글쓰기에 적합한 유일한 AI 문법 및 언어 검사 도구입니다. Trinka는 문법 차원을 넘어, 어조, 스타일, 가독성 등 많은 측면에서 귀하의 글을 개선해 출판할 준비를 갖춥니다!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Trinka - 학술 및 기술 글쓰기에 적합한 문법 검사' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka는 학술 및 기술 글쓰기에 적합한 유일한 AI 문법 및 언어 검사 도구입니다. Trinka는 문법 차원을 넘어, 어조, 스타일, 가독성 등 많은 측면에서 귀하의 글을 개선해 출판할 준비를 갖춥니다!" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('main_header').classList.remove('homepageHeader');
    }

  }
}
